// Member rows another part of the app has just changed on the server, for
// every chart that may hold an old copy of them.
//
// The workspace keeps every open tab MOUNTED (PedigreeWorkspaceHost), and each
// tab's chart holds its own memberRecords and runs its own autosave. That
// autosave POSTs every member's whole row, and the server $sets each
// non-proband row wholesale. So when a write made from ONE tab changes a
// person who is also a row in ANOTHER tab's chart, that other chart is holding
// a stale row, and its next save writes the old values back over the change.
//
// The person-link sync is that write: saving a linked person's details in one
// tab writes their name, date of birth and sex onto each linked secondary
// record, in other families (POST /person-links/sync-secondaries), and any of
// those families can be open in another tab.
//
// So the writer announces what it changed, by person number, and every
// mounted chart that holds one of those rows refreshes it from the server
// before its autosave may send it (useExternalMemberRowRefresh). A module
// value rather than workspace state, in the manner of unsavedWork.js: the
// announcement is an event, not something to render, every chart is in the
// same page, and it works the same with the workspace flag off (one chart,
// which then simply finds nothing to refresh unless it holds the row).
//
// A change is
//   { memberIds: string[],  person numbers written: familyMemberId, or the
//                           proBandId of a family root
//     fields: string[],     the row fields the write set
//     patch: object,        what it set them to, exactly as the server $set
//                           them - the fallback when a refresh cannot be read
//     source: string }      who wrote it, for diagnostics

const listeners = new Set();

/** Listen for changes. Returns the unsubscribe. */
export const subscribeToMemberRowChanges = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Tell every mounted chart. A listener that throws is reported and does not
 * stop the others hearing it.
 */
export const announceMemberRowChanges = (change) => {
  if (!change || !Array.isArray(change.memberIds) || !change.memberIds.length) {
    return;
  }
  [...listeners].forEach((listener) => {
    try {
      listener(change);
    } catch (err) {
      console.error('A member-row change listener failed:', err);
    }
  });
};

// For tests: module state outlives a render.
export const resetMemberRowChanges = () => listeners.clear();
